import { Types } from '@store/types';

const initialValue = { IsShowViewQuarterlyBtn: false, IsShowMonthView: false, selectedCRMTarget: null };

const CRMCommonReducer = (state = initialValue, action) => {
	switch (action.type) {
		case Types.SET_CRM_OWN_CONFIGURATION:
			return { ...state, myConfiguration: action.payload };
		case Types.TOGGLE_CRM_VIEW_QUARTER_BTN:
			return { ...state, IsShowViewQuarterlyBtn: action.payload };
		case Types.TOGGLE_CRM_MONTH_VIEW:
			return { ...state, IsShowMonthView: action.payload };
		case Types.IS_REQUEST_COMES_FROM_OUTSIDE_OF_CRM:
			return { ...state, selectedCRMTarget: action.payload };
		default:
			return state;
	}
};

export default CRMCommonReducer;
